module.exports = " <div id=list-wrapper> <h2> PlayList: </h2> <ul class=container> <song v-for=\"item in list\" :item=item :remove-btn=true :index=$index></song> </ul> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/PlayList.vue
// module id = 164
// module chunks = 2